const ACTIVE = "#22C55E";
const BASE = "#33415A";
const SIL = "#141B27";
const SIL_STROKE = "#2A3550";

function f(g, active) {
  return active.includes(g) ? ACTIVE : BASE;
}
function op(g, active) {
  return active.includes(g) ? 0.95 : 0.5;
}

function FrontView({ active }) {
  return (
    <svg viewBox="0 0 150 330" className="w-full h-full" data-testid="muscle-map-front">
      {/* silhouette */}
      <g fill={SIL} stroke={SIL_STROKE} strokeWidth="1.4">
        <circle cx="75" cy="26" r="15" />
        <path d="M67 40 h16 l3 8 q18 4 22 20 l4 26 q-1 8 -8 8 l-6 -2 -3 -20 -2 34 q-1 40 -4 78 l-2 40 q-1 22 -5 24 h-8 q-3 -2 -3 -22 l-2 -48 -2 48 q0 20 -3 22 h-8 q-4 -2 -5 -24 l-2 -40 q-3 -38 -4 -78 l-2 -34 -3 20 -6 2 q-7 0 -8 -8 l4 -26 q4 -16 22 -20 z" />
      </g>
      {/* deltoids */}
      <path d="M50 50 q-11 2 -14 13 q9 -3 16 -2 z" fill={f("Ombro", active)} opacity={op("Ombro", active)} />
      <path d="M100 50 q11 2 14 13 q-9 -3 -16 -2 z" fill={f("Ombro", active)} opacity={op("Ombro", active)} />
      {/* chest */}
      <path d="M56 56 q-8 3 -8 14 q0 8 10 9 q9 0 10 -8 l0 -12 q-6 -4 -12 -3 z" fill={f("Peito", active)} opacity={op("Peito", active)} />
      <path d="M94 56 q8 3 8 14 q0 8 -10 9 q-9 0 -10 -8 l0 -12 q6 -4 12 -3 z" fill={f("Peito", active)} opacity={op("Peito", active)} />
      {/* abs */}
      <path d="M64 82 q11 -3 22 0 l-2 34 q-1 8 -9 8 q-8 0 -9 -8 z" fill={f("Core/Abdômen", active)} opacity={op("Core/Abdômen", active)} />
      {/* biceps */}
      <path d="M43 58 q-8 3 -9 14 l-2 16 q6 3 11 1 l3 -16 z" fill={f("Bíceps", active)} opacity={op("Bíceps", active)} />
      <path d="M107 58 q8 3 9 14 l2 16 q-6 3 -11 1 l-3 -16 z" fill={f("Bíceps", active)} opacity={op("Bíceps", active)} />
      {/* forearms */}
      <path d="M31 90 q5 3 11 1 l-2 30 q-5 2 -10 0 z" fill={f("Antebraço", active)} opacity={op("Antebraço", active)} />
      <path d="M119 90 q-5 3 -11 1 l2 30 q5 2 10 0 z" fill={f("Antebraço", active)} opacity={op("Antebraço", active)} />
      {/* quads */}
      <path d="M56 150 q9 -3 15 0 l-2 60 q-1 8 -6 8 q-5 0 -6 -8 z" fill={f("Pernas", active)} opacity={op("Pernas", active)} />
      <path d="M94 150 q-9 -3 -15 0 l2 60 q1 8 6 8 q5 0 6 -8 z" fill={f("Pernas", active)} opacity={op("Pernas", active)} />
      {/* shins */}
      <path d="M57 222 q6 -2 11 0 l-2 54 q-1 6 -4 6 q-3 0 -4 -6 z" fill={f("Panturrilha", active)} opacity={op("Panturrilha", active)} />
      <path d="M93 222 q-6 -2 -11 0 l2 54 q1 6 4 6 q3 0 4 -6 z" fill={f("Panturrilha", active)} opacity={op("Panturrilha", active)} />
    </svg>
  );
}

function BackView({ active }) {
  return (
    <svg viewBox="0 0 150 330" className="w-full h-full" data-testid="muscle-map-back">
      <g fill={SIL} stroke={SIL_STROKE} strokeWidth="1.4">
        <circle cx="75" cy="26" r="15" />
        <path d="M67 40 h16 l3 8 q18 4 22 20 l4 26 q-1 8 -8 8 l-6 -2 -3 -20 -2 34 q-1 40 -4 78 l-2 40 q-1 22 -5 24 h-8 q-3 -2 -3 -22 l-2 -48 -2 48 q0 20 -3 22 h-8 q-4 -2 -5 -24 l-2 -40 q-3 -38 -4 -78 l-2 -34 -3 20 -6 2 q-7 0 -8 -8 l4 -26 q4 -16 22 -20 z" />
      </g>
      {/* rear delts */}
      <path d="M50 50 q-11 2 -14 13 q9 -3 16 -2 z" fill={f("Ombro", active)} opacity={op("Ombro", active)} />
      <path d="M100 50 q11 2 14 13 q-9 -3 -16 -2 z" fill={f("Ombro", active)} opacity={op("Ombro", active)} />
      {/* back / lats */}
      <path d="M56 56 q-9 4 -9 16 l2 22 q0 8 8 9 l10 2 0 -49 q-6 -3 -11 0 z" fill={f("Costas", active)} opacity={op("Costas", active)} />
      <path d="M94 56 q9 4 9 16 l-2 22 q0 8 -8 9 l-10 2 0 -49 q6 -3 11 0 z" fill={f("Costas", active)} opacity={op("Costas", active)} />
      {/* triceps */}
      <path d="M43 58 q-8 3 -9 14 l-2 16 q6 3 11 1 l3 -16 z" fill={f("Tríceps", active)} opacity={op("Tríceps", active)} />
      <path d="M107 58 q8 3 9 14 l2 16 q-6 3 -11 1 l-3 -16 z" fill={f("Tríceps", active)} opacity={op("Tríceps", active)} />
      {/* forearms */}
      <path d="M31 90 q5 3 11 1 l-2 30 q-5 2 -10 0 z" fill={f("Antebraço", active)} opacity={op("Antebraço", active)} />
      <path d="M119 90 q-5 3 -11 1 l2 30 q5 2 10 0 z" fill={f("Antebraço", active)} opacity={op("Antebraço", active)} />
      {/* glutes */}
      <path d="M64 118 q11 -4 22 0 l0 12 q-1 12 -11 12 q-10 0 -11 -12 z" fill={f("Glúteo", active)} opacity={op("Glúteo", active)} />
      {/* hamstrings */}
      <path d="M56 150 q9 -3 15 0 l-2 60 q-1 8 -6 8 q-5 0 -6 -8 z" fill={f("Pernas", active)} opacity={op("Pernas", active)} />
      <path d="M94 150 q-9 -3 -15 0 l2 60 q1 8 6 8 q5 0 6 -8 z" fill={f("Pernas", active)} opacity={op("Pernas", active)} />
      {/* calves */}
      <path d="M57 222 q6 -2 11 0 l-2 54 q-1 6 -4 6 q-3 0 -4 -6 z" fill={f("Panturrilha", active)} opacity={op("Panturrilha", active)} />
      <path d="M93 222 q-6 -2 -11 0 l2 54 q1 6 4 6 q3 0 4 -6 z" fill={f("Panturrilha", active)} opacity={op("Panturrilha", active)} />
    </svg>
  );
}

export default function MuscleMap({ groups = [], showLegend = false, showTitle = false, className = "" }) {
  const active = Array.from(new Set(groups));
  return (
    <div className={className} data-testid="muscle-map">
      {showTitle && <h4 className="text-xs font-medium text-slate-400 mb-2 text-center">Músculos trabalhados</h4>}
      <div className="flex items-end justify-center gap-4">
        <div className="flex flex-col items-center gap-1">
          <div className="w-20 sm:w-24"><FrontView active={active} /></div>
          <span className="text-[10px] uppercase tracking-wider text-slate-500">Frente</span>
        </div>
        <div className="flex flex-col items-center gap-1">
          <div className="w-20 sm:w-24"><BackView active={active} /></div>
          <span className="text-[10px] uppercase tracking-wider text-slate-500">Costas</span>
        </div>
      </div>
      {showLegend && active.length > 0 && (
        <div className="flex flex-wrap gap-1.5 justify-center mt-3">
          {active.map((g) => (
            <span key={g} className="text-[11px] px-2 py-0.5 rounded-md bg-emerald-500/15 text-emerald-400 border border-emerald-500/30">{g}</span>
          ))}
        </div>
      )}
    </div>
  );
}
